import MarketplaceJSON from '../Utils/ABI/Contracts/Marketplace.sol/Marketplace.json';
import GeoTagJSON from '../Utils/ABI/Contracts/GeoTag.sol/GeoTag.json';
import DigitalLandJSON from '../Utils/ABI/Contracts/DigitalLand.sol/DigitalLand.json';
import UserSaleJSON from '../Utils/ABI/Contracts/UserSale.sol/UserSale.json';
import SimuleTokenABI from '../Utils/ABI/Contracts/SimuleToken.sol/SimuleToken.json';
const isLocal = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
);
const isProd = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';

export const WebConfig = {
    mapboxAccessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || 'pk.eyJ1IjoiamVldml0aGEtc2ltdWxlIiwiYSI6ImNsbWdodXZxbDBjdXEzZXIydzkxZmpuZzAifQ.0p131QYw_QQ8Ntnn8UTvrg',
    apiURL: (process.env.REACT_APP_API_URL) || (isProd ? 'https://simule-vb-middleware.onrender.com' : (isLocal ? 'http://localhost:5000' : 'https://simule-vb-middleware.onrender.com')),
    apiLocal: (process.env.REACT_APP_API_URL) || (isProd ? 'https://simule-vb-middleware.onrender.com' : (isLocal ? 'http://localhost:5000' : 'https://simule-vb-middleware.onrender.com')),
    digitalLandAddress: '0x35C5ab4B059B1Cd22edb99f47f7379d68269284F',
    simuleTokenAddress: '0xf95e8c782d3ac44218634ac41f9e742422e46e7c',
    geoTagAddress: '0xd548E0321A673c6f1d96964B12A65aEF1446a181',
    marketplaceAddress: '0x532E1369979066852DCdDC0f815640d7911d9DE2',
    usersaleAddress: '0x455fE13C10E11023660AEd9bDE98fA07be6C9b01',
    gasLimit: 9000000,
    rpcUrl: 'https://ethereum-sepolia-rpc.publicnode.com/',
    chainName: 'Sepolia Testnet',
    chainId: 11155111,
    nativeCurrencyName: 'SepoliaETH',
    nativeCurrencyDecimals: 18,
    nativeCurrencySymbol: 'SepoliaETH',
    blockExplorerUrl: 'https://sepolia.etherscan.io/',
    marketplaceABI: MarketplaceJSON.abi,
    geoTagABI: GeoTagJSON.abi,
    digitalLandABI: DigitalLandJSON.abi,
    usersaleABI: UserSaleJSON.abi,
    simuleTokenABI: SimuleTokenABI.abi,
    
    // Reown AppKit configuration
    appKit: {
        projectId: "6f24d6232671faa8ef00393a0e951f3e", // Your WalletConnect project ID
        metadata: {
            name: "Simule",
            description: "Simule Web3 Application",
            url: window.location.origin,
            icons: [window.location.origin + "/logo192.png"]
        }
    },
    // Wallet auth settings
    walletAuth: {
        signatureMaxAgeMs: 2 * 60 * 60 * 1000
    }
}
